import type { SVGProps } from 'react';

const Svg6FtApart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 2 9.43V10h8zM18 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 14 9.43V10h8zM19 17v-2.01L5 15v2l-3-3 3-3v2.01L19 13v-2l3 3zm-9 2v-1H7v4h3v-2.5H8V19zm-1 1.5v.5H8v-.5zm8.5-1.5h-1v3h-1v-3h-1v-1h3zm-5 0v.5h1v1h-1V22h-1v-4H14v1z" />
  </svg>
);
export default Svg6FtApart;
